export default __webpack_public_path__ + "static/media/schmoedown-point-system-pt2.8438ba42.png";